export const WORKFLOW = [
    {
        "id": 0,
        "name": "Introduction",
        "hideFromNav": true
    },
    {
        "id": 1,
        "name": "Model Overview"
    },
    {
        "id": 2,
        "name": "Time Taken"
    },
    {
        "id": 3,
        "name": "Value of Time"
    },
    {
        "id": 4,
        "name": "Scenario Creation"
    },
    {
        "id": 5,
        "name": "Results"
    },
    {
        "id": 6,
        "name": "References",
        "hideFromNav": true
    },
    {
        "id": 7,
        "name": "Additional Context",
        "hideFromNav": true
    }
  ]